import { MMONetworkSlave } from "@utils/types";
import { InteractableData } from "mmo-common/src/game/models/interactable.model";
import { GameObject } from "realms-engine";

export class SlaveInteractableGameObject
  extends GameObject
  implements MMONetworkSlave<"interactable">
{
  private state: InteractableData;

  constructor(state: InteractableData) {
    super();
    this.state = state;
  }

  getState(): InteractableData {
    return this.state;
  }

  onSlaveChanges(
    changes: Partial<InteractableData>,
    newState: InteractableData,
    oldState: InteractableData
  ): void {
    this.state = newState;
  }
}
